import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

import { type AIInteractionTypeEnum } from './ai'

export enum SourceType {
  SourceWebsite = 'SourceWebsite',
  SourceDocument = 'SourceDocument',
  SourceFAQ = 'SourceFAQ',
  SourceAPI = 'SourceAPI',
  SourceTransferLine = 'SourceTransferLine',
  SourcePoliProcess = 'SourcePoliProcess',
  SourceGISLayer = 'SourceGISLayer',
}

export const ResponseTypeEnum = schemas.ResponseTypeEnum
export const AgentActionTypeEnum = schemas.AgentActionTypeEnum

export type EnrichedQuery = z.infer<typeof schemas.EnrichedQuery>
export type EnrichedResponse = z.infer<typeof schemas.EnrichedResponse>
export type SourceDisplayLink = z.infer<typeof schemas.SourceDisplayLink>
export type AIInteractionTranscript = z.infer<typeof schemas.AIInteractionTranscript>
export type AIInteractionSummary = z.infer<typeof schemas.AIInteractionSummary>
export type AgentTraceNode = z.infer<typeof schemas.AgentTraceNode>
export type ResponseTypeEnumType = z.infer<typeof ResponseTypeEnum>
export type AgentActionTypeEnumType = z.infer<typeof AgentActionTypeEnum>

export type CaseDisplayLink = z.infer<typeof schemas.CaseDisplayLink>
export type ContactDisplayLink = z.infer<typeof schemas.ContactDisplayLink>
export type AssistantAttachmentDisplay = z.infer<typeof schemas.EnrichedAttachment>
export type CreatedSkill = z.infer<typeof schemas.CreatedSkill>
export type UploadedAssistantAttachment = z.infer<
  typeof schemas.UploadAssistantAttachmentViewResponseData
>

export interface ChatStreamStatusStats {
  query?: string
  count?: number
  total?: number
  firstName?: string
  name?: string
  layerName?: string
  success?: boolean
  endpoint?: string
  totalFound?: number
  entityType?: string
}

export interface ChatStreamStepEntry {
  step: string
  startedStats?: ChatStreamStatusStats
  completeStats?: ChatStreamStatusStats
}

// String entries are legacy steps persisted before status stats existed
export type ChatStreamStepItem = ChatStreamStepEntry | string

export interface IAIInteractionMessageDisplay {
  id: string | null
  text: string
  sender: 'USER' | 'AI' | 'ACTION'
  timestamp: Date
  impression: boolean | null
  feedback?: string
  submitter?: string
  feedbackCreated?: Date
  responseType?: ResponseTypeEnumType | null
  actionType?: AgentActionTypeEnumType | null
  sources?: SourceDisplayLink[]
  cases?: CaseDisplayLink[]
  contacts?: ContactDisplayLink[]
  files?: AssistantAttachmentDisplay[]
  skills?: CreatedSkill[]
  hasIntegrations?: boolean
  attachments?: AssistantAttachmentDisplay[]
  location?: {
    address: string
    lat: number
    lon: number
  }
  streamSteps?: ChatStreamStepItem[]
}

export interface IQuery {
  id: string
  aiInteractionId: string
  body: string
  created: Date
}

export interface IResponse {
  id: string
  aiInteractionId: string
  body: string
  created: Date
  impression?: boolean
}

export interface IChat {
  id: string
  organizationId: string
  userId: string
  created: Date
  caseId?: string
  queries: IQuery[]
  responses: IResponse[]
  type: AIInteractionTypeEnum
}

export interface IGraphNode {
  name: string
  labels: string[]
}
export interface IGraphData {
  nodes: IGraphNode[]
}

export type RetrieveSourcesViewResponseData = z.infer<
  typeof schemas.ElevenLabsRetrieveSourcesViewResponseData
>
export interface IRetrievalResult {
  chunks: SourceDisplayLink[]
  pages?: SourceDisplayLink[]
  graph_data?: IGraphData
  metrics?: unknown
}
